import axios from 'axios';
import SITE_SETTINGS from 'src/constants/whiteLabel';

const baseURL =
    SITE_SETTINGS.apiCalls[process.env.REACT_APP_NODE_ENV || 'development'];

export default axios.create({
    baseURL,
});
